<template>
  <div class="wrapper">
    <img :src="img" :alt="title" />
    <p>{{ title }}</p>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: $color-stage1;
  img {
    width: 120px;
    height: 120px;
  }
  p {
    color: $color-stage4;
    font-size: $base-font-size;
    line-height: 22px;
    text-align: center;
    @include font-Medium;
  }
}
</style>
